import {
  fetchOperation,
  putOperation,
  getOperation,
  getMaster,
} from "utils/api";

export const queryAgentDetail = async (isoAgentId) => {
  return await getOperation(`/agent/${isoAgentId}`);
};

export const queryAgentMerchant = async (params) => {
  return await getOperation("/merchant/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const resetPassword = async (params) => {
  return await fetchOperation("/admin/reset/password", {
    ...params,
  });
};

export const updateStatus = async (params) => {
  const { isoAgentId, ...rest } = params;
  return await putOperation(`/agent/${isoAgentId}`, {
    ...rest,
  });
};

export const getRoleList = async (params) => {
  return await getMaster("/roles", {
    sort: "id,asc",
    ...params,
  });
};
